import { Button, Card, Grid, Icons, Text } from "@pushpress/shared-components";

export default function ErrorState({ refetch }: { refetch: () => void }) {
  return (
    <Grid item marginX={10} md={7} xs={12} style={{ marginTop: "5rem" }}>
      <Card className="p-4">
        <Grid container alignItems="center" direction="column">
          <Grid item>
            <Icons.Alert
              style={{ height: "30px", width: "30px", color: "red" }}
            />
          </Grid>
          <Grid item>
            <Text variant="body-lg">
              We couldn&apos;t load the migration assistant.
            </Text>
          </Grid>
          <Grid item>
            <Text color="wolf-600">
              This could be due to a network issue or a temporary problem on our
              end.
            </Text>
          </Grid>
          <Grid item>
            <Button size="small" text="Retry" onClick={() => refetch()} />
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}
